import { CheckIcon, ClipboardDocumentIcon } from "@heroicons/react/16/solid";
import { useContext, useState } from "react";
import { OverflowFrame } from "../../../externalComponents";
import { PageHeading } from "../../../externalComponents/PageHeading";
import { SettingsSidebar } from "../../../externalComponents/SettingsSidebar";
import { Button } from "../../../externalComponents/tailwind/button";
import { Divider } from "../../../externalComponents/tailwind/divider";
import { Field, Legend } from "../../../externalComponents/tailwind/fieldset";
import { Heading } from "../../../externalComponents/tailwind/heading";
import { Input } from "../../../externalComponents/tailwind/input";
import { Text } from "../../../externalComponents/tailwind/text";
import { CustomerContext } from "../../../providers";
import { useCompanyUsers } from "./hooks";

export default function GeneralUsersPage() {
  const { user, customer } = useContext(CustomerContext);
  const { users, isLoading, saveUsersSettings, updateUser } = useCompanyUsers();
  const [copied, setCopied] = useState(false);

  const copyInvitationLink = async () => {
    const invitationUrl = `${window.location.origin}/dashboard?invitation_code=${user.customer.codeForLogin}&company_name=${encodeURIComponent(user.customer.name)}`;
    try {
      await navigator.clipboard.writeText(invitationUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error("Failed to copy link:", error);
    }
  };

  return (
    <>
      <SettingsSidebar>
        <PageHeading
          title="Users"
          primaryAction="Save"
          handlePrimaryAction={saveUsersSettings}
          isPrimaryLoading={isLoading}
        />
        <OverflowFrame>
          {user?.customer?.codeForLogin && (
            <>
              {!customer.azureTenantId && (
                <div className="my-5">
                  <Heading className="text-lg">Invite users by link</Heading>
                  <div className="flex items-center gap-3">
                    <Text className="flex-1">
                      {window.location.origin}/dashboard?company_name=
                      {encodeURIComponent(user.customer.name)}&invitation_code=
                      {user.customer.codeForLogin}
                      <Button
                        color="primaryButton"
                        onClick={copyInvitationLink}
                        className="ml-2"
                      >
                        {copied ? (
                          <CheckIcon className="w-4 h-4" />
                        ) : (
                          <ClipboardDocumentIcon className="w-4 h-4" />
                        )}
                        {copied ? "Copied!" : "Copy link"}
                      </Button>
                    </Text>
                  </div>
                </div>
              )}
              <Divider />
            </>
          )}
          <div className="my-5">
            <Heading className="text-lg">Company users</Heading>
            {users &&
              customer?.id !== "1138" &&
              users.map((user, index) => (
                <div key={index} className="grid grid-cols-3 gap-5">
                  <Field>
                    <Legend>Email</Legend>
                    <Input
                      name="Email"
                      value={user.email}
                      disabled
                      autoComplete="off"
                      maxLength={200}
                    />
                  </Field>
                  <Field>
                    <Legend>First Name</Legend>
                    <Input
                      name="First Name"
                      value={user.firstName}
                      onChange={(e) =>
                        updateUser(user.email, "firstName", e.target.value)
                      }
                      autoComplete="off"
                      maxLength={32}
                    />
                  </Field>
                  <Field>
                    <Legend>Last Name</Legend>
                    <Input
                      name="Last Name"
                      value={user.lastName}
                      onChange={(e) =>
                        updateUser(user.email, "lastName", e.target.value)
                      }
                      autoComplete="off"
                      maxLength={32}
                    />
                  </Field>
                </div>
              ))}
          </div>
        </OverflowFrame>
      </SettingsSidebar>
    </>
  );
}
